export default {
  "Movements queue":"Cola de movimientos",
  "Language":"Idioma",
  "Updated successfully":"Actualizado con éxito",
  "User Settings":"Configuración de usuario",
  "Exit":"Salir",
  "Warehouse":"Almacén",
  "Movements history":"Historial de movimientos",
  "Stock":"Inventario",
  "Masters":"Maestros",
  "Machines":"Máquinas",
  "Positions":"Posiciones",
  "Containers":"Contenedores",
  "Families":"Familias",
  "Users":"Usuarios",
  "Admin setings":"Configuración de administrador",
  "Params":"Parámetros",
  "Logs":"Registros",
  "App settings":"Configuración de la aplicación",
  "Waiting":"Esperando",
  "Working":"Trabajando",
  "Communication lost":"Comunicación perdida",
  "Without communication":"Sin comunicación",
  "Name":"Nombre",
  "User name":"Nombre de usuario",
  "Required":"Requerido",
  "Old password":"Contraseña antigua",
  "New password":"Nueva contraseña",
  "The passwords not match":"Las contraseñas no coinciden",
  "Repeat password":"Repetir contraseña",
  "Dark theme":"Tema oscuro",
  "Setings":"Ajustes",
  "Are you sure you want to delete machine %s ?":"Are you sure you want to delete machine {machine} ?",
  "actions":"Acciones",
  "Machines":"Maquinas",
  "machineId":"Identificador de Maquina",
  "type":"tipo",
  "Abbreviation":"Abreviatura",
  "Priority":"Prioridad",
  "Description":"Descripción",
  "Search":"Buscar",
  "containerNumber":"Numero de pallet",
  "width":"Ancho",
  "height":"Alto",
  "large":"largo",
  "containersType":"Tipo de pallet",
  "ID":"Identificador",
  "PosX":"Posicion X",
  "PosY":"Posicion Y",
  "PosZ":"Posicion Z",
  "maxDepth":"Profundidad maxima",
  "PositionType":"Tipo de posicion",
  "physicalPositions":"Posiciones Físicas",
  "tracks":"Caminos",
  "originId":"ID de origen",
  "destinationMachine": "Maquina de destino",
  "destinationId":"ID de destino",
  "positionId":"ID de Posición",
  "New track":"Camino Nuevo",
  "Edit track":"Editar Camino",
  "Add new position":"Añadir nueva posicion",
  "Minimum 2 characters to trigger filtering":"Mínimo 2 caracteres para activar el filtrado",
  "Save":"Guardar",
  "Update":"Actualizar",
  "New machine":"Nueva Maquina",
  "Edit machine":"Edita la Maquina",
  "skuFamilyId":"Identificador de UMS",
  "skuFamilyDescription":"Descripción de UMS",
  "MachineType":"Tipo de maquina",
  "New family":"Nueva Familia",
  "Edit family":"Edita la familia",
  "family added succefully":"familia añadida exitosamente",
  "family updated succefully":"familia actualizada exitosamente",
  "familyId":"Identificador de Familia",
  "RotationZones":"Categorías ABC",
  "RotationZoneId":"Identificador de categoría ABC",
  "Created":"Creado",
  "Edit rotationZone":"Editar categoría ABC",
  "New rotationZone":"Crear categoría ABC",
  "DangerIndicators":"Indicadores de peligro",
  "Edit dangerIndicator":"Editar indicador de peligro",
  "New dangerIndicator":"Crear indicador de peligro",
  "Danger Indicator deleted successfully":"Indicador de peligro eliminado éxitosamente",
  "Are you sure you want to delete DangerIndicator %s ?":"¿Está seguro de que desea eliminar la máquina {dangerIndicator} ?",
  "Delete danger indicator":"Borrar indicador de peligro",
  "Danger indicator added succefully":"Indicador de peligro añadido correctamente",
  "Delete family":"Borrar Familia",
  "Are you sure you want to delete family %s ?":"¿Está seguro de que desea eliminar la familia {family} ?",
  "rotationZone added succesfully":"Categoría ABC añadida satisfactoriamente",
  "rotationZone updated succesfully":"Categoría ABC actualizada satisfactoriamente",
  "rotationZone delete successfully":"Categoría ABC eliminada correctamente",
  "Delete rotationZone":"Borrar Zona de rotación",
  "Are you sure you want to delete rotationZone %s ?":"¿Está seguro de que desea eliminar la categoría ABC {rotationZone}?",
  "Are you sure you want to delete machine %s ?":"¿Está seguro de que desea eliminar la máquina {machine}?",
  "Machine added succefully":"Máquina añadida con éxito",
  "Machine updated succefully":"Máquina actualizada con éxito",
  "Machine delete successfully":"Máquina eliminada con éxito",
  "Delete machine":"Borrar maquina",
  "stock":"Inventario",
  "palletId":"Identificador de palet",
  "physicalPositionId":"Identificador de posición fisica",
  "cmPosition":"Posición del CM",
  "batchControl":"Control de lote",
  "clientCode":"Código del cliente",
  "expireControl":"Control de caducidad",
  "minimumUsefulLife":"Vida útil mínima",
  "quarentineTime":"Tiempo de cuarentena",
  "rawMaterial":"Materia prima",
  "rawWeight":"Peso bruto",
  "serialControl":"Control de serie",
  "skuDescription":"Descripción del SKU",
  "skuId":"SKU",
  "skuShortDescription":"Descripción corta del SKU",
  "stackable":"Apilable",
  "totalUsefulLife":"Vida útil total",
  "weightControl":"Control de peso",
  "containerType":"ID del tipo de pallet",
  "dangerIndicator":"ID del indicador de peligro",
  "family":"ID de familia",
  "managmentMethodId":"ID del método de gestión",
  "measurementUnit":"ID de la unidad de medida",
  "minimumUsefulLifeTimeMeasurement":"ID de las medidas del tiempo de vida útil mínima",
  "quarentineTimeMeasurement":"ID de las medidas del tiempo de cuarentena",
  "rotationZone":"ID de la categoría ABC",
  "totalUsefulLifeTimeMeasurement":"ID de las medidas del tiempo de vida útil total",
  "machineId":"ID de la máquina",
  "items":"Artículos",
  "New item":"Elemento nuevo",
  "Edit item":"Editar elemento",
  "updated":"Actualizado",
  "intermediateId":"ID intermedio",
  "currentPositionId":"ID posición actual",
  "taskId":"ID de tarea",
  "movementType":"Tipo de movimiento",
  "status":"Estado",
  "Inbound":"Entrada",
  "Outbound":"Salida",
  "Relocation":"Reubicación",
  "noDataAvailable":"Datos no disponibles",
  "palletNumber":"Cantidad de pallets",
  "skuUnits":"Unidades de sku",
  "expireDate":"Fecha de caducidad",
  "send":"Enviar",
  "add":"Añadir",
  "Add at least one item in the list":"Agregue al menos un elemento a la lista",
  "errorType":"Tipo de error",
  "deleted":"Eliminado",
  "RESTING":"En reposo",
  "WAITING":"Esperando",
  "SENT":"Enviado",
  "SUCCESS":"Éxito",
  "PENDING":"Pendiente",
  "PROCESSING": "En proceso",
  "ERROR":"Error",
  "COMPLETED":"Completado",
  "COMPLETED_MANUALLY":"Completado manualmente",
  "COMPLETED_WITH_ERRORS":"Completado con errores",
  "CANCELED":"Cancelado",
  "REJECTED":"Rechazado",
  "close":"Cerrar",
  "Please enter a expire date":"Por favor ingrese una fecha de vencimiento",
  "noResults":"Sin resultados",
  "searchType":"Tipo de busqueda",
  "unitsRequested":"Unidades solicitadas",
  "pickingZone":"Zona de picking",
  "high":"Alta",
  "medium":"Media",
  "low":"Baja",
  "Please input the pallet ID":"Por favor, introduzca el ID del palé",
  "Please input pallet number":"Por favor, introduzca el número de palés",
  "Please select a pallet type":"Por favor, seleccione un tipo de palé",
  "Please enter units":"Por favor, introduzca las unidades",
  "Please select a search type":"Por favor, selecciona el tipo de busqueda",
  "Please select a SKU":"Por favor, selecciona un SKU",
  "Please select a position":"Por favor, selecciona una posicion",
  "Please select a position":"Por favor, selecciona una maquina",
  "delete":"Eliminar",
  "Enter the destination location where you want to place this pallet":"Ingrese la ubicación de destino donde desea colocar este palet",
  "Delete movement":"Eliminar movimiento",
  "Are you sure you want to delete movement with palleId %s?":"¿Estás seguro de que quieres eliminar el movimiento con palletId {palletId}?",
  "Are you sure you want to finish movement with palleId %s?":"¿Estás seguro de que quieres finalizar el movimiento con palletId {palletId}?",
  "The movement will be deleted":"El movimiento se eliminará y el pallet permanecerá en su posición de origen. Si se trata de un movimiento de entrada, el pallet no se almacenará en el almacén.",
  "The movement will be completed":"El movimiento se completará a la posición de destino. Si se trata de un movimiento de salida, el pallet se eliminará del almacén.",
  "totalQuantity":"Cantidad Total",
  "warehouseZone":"Zona de almacén",
  "Item added succefully":"Artículo añadido correctamente",
  "Item updated succefully":"Artículo actualizado correctamente",
  "Edit physicalPosition":"Editar posición física",
  "inboundLock":"Bloqueo de entrada",
  "exitLock":"Bloqueo de salida",
  "fullLock":"Bloqueo completo",
  "ExploitationCenter":"Centro de explotación",
  "LocationType":"Tipo de ubicación",
  "AisleNumber":"Número de pasillo",
  "Laterality":"Lateralidad",
  "BayNumber":"Número de bahía",
  "LevelNumber":"Número de nivel",
  "LocationCode":"Código de ubicación",
  "InUse":"En uso",
  "ReservedEntrance":"Entrada reservada",
  "ReservedExit":"Salida reservada",
  "Side":"Lado",
  "Bay":"Bahía",
  "Level":"Nivel",
  "generalLock":"Bloqueo general",
  "superAdminLock":"Bloqueo de super administrador",
  "Position":"Posición",
  "Inbound":"Entrada",
  "Outbound":"Salida",
  "Relocation":"Reubicación",
  "INBOUND":"Entrada",
  "OUTBOUND":"Salida",
  "RELOCATION":"Reubicación",
  "PICKING":"Picking",
  "RETURN_HOME":"Retorno a casa",
  "picking":"Picking",
  "dateRange":"Rango de fechas",
  "HUBMASTER - Location catalog":"HUBMASTER - Catálogo de ubicaciones",
  "Select the block to apply in the location":"Seleccione el bloque a aplicar en la ubicación",
  "Indicate the reason for blocking the location":"Indique el motivo para bloquear la ubicación",
  "depth":"Profundidad",
  "moreInfo":"Más información",
  "quantity":"Cantidad",
  "atHome":"En reposo",
  "itemId":"ID del articulo",
  "managementMethod":"Método de gestión",
  "outboundLock":"Bloqueo de salida",
  "totalUsefulLifeTimeMeasurement":"Medición de vida útil total",
  "requiredfield":"Campo requerido",
  "visibleComlumns":"Columnas visibles",
  "frontOverhang":"Voladizo delantero",
  "backOverhang":"Voladizo trasero",
  "rejectReasonCode":"Código de motivo de rechazo",
  "monday":"Lunes",
  "tuesday":"Martes",
  "wednesday":"Miércoles",
  "thursday":"Jueves",
  "friday":"Viernes",
  "saturday":"Sábado",
  "sunday":"Domingo",
  "stockExcel":"Inventory Alignment",
  "compactionHm1":"Compactación HM1",
  "compactionHm2":"Compactación HM2",
  "compactionHm3":"Compactación HM3",
  "rotationZoneAssignment":"Assignación de zonas de rotación",
  "photostock":"Photostock",
  "tasks":"Tareas",
  "update":"Actualizar",
  "disabled":"Deshabilitado",
  "enabled":"Habilitado",
  "taskLog":"Registro de tareas",
  "taskName":"Nombre de la tarea",
  "stop":"Parar",
  "finished":"Finalizada",
  "working":"Trabajando",
  "Lock position updated succefully":"Posición de bloqueo actualizada correctamente",
  "Reason is required":"Se requiere un motivo",
  "Alarms":"Alarmas",
  "alarmId":"Id de la alarma",
  "alarmStatus":"Estado de la alarma",
  "alarmName":"Nombre de la alarma",
  "problemDescription":"Descripción del problema",
  "created":"Creado",
  "deleted":"Eliminado",
  "Alarm Update Succesfully":"Alarma actualizada correctamente",
  "Active":"Activo",
  "Solved":"Resuelto",
  "block":"bloqueo",
  "blockPositionType":"Tipo de posición de bloqueo",
  "viewBlock":"Visualizador de Bloqueos",
  "stockRemove":"Eliminar confirmación",
  "You confirm that pallet with ID {palletId} is no longer in location {physicalPositionId}?":"¿Confirma que el palé con ID {palletId} ya no está en la ubicación {physicalPositionId}?",
  "serverTime":"Fecha y hora local del servidor",
  "alternativeId":"Id alternativa",
  "Select Positions":"Seleccionar posiciones",
  "Block Positions":"Bloquear",
  "Unblock Positions":"Desbloquear",
  "Selected Positions:":"Posiciones seleccionadas:",
  "Select Block Type":"Seleccione el tipo de bloqueo",
  "Please provide necessary data":"Por favor, proporcione los datos necesarios",
  "Cancel":"Cancelar",
  "Are you sure you want to unblock the following positions?":"¿Está seguro de que desea desbloquear las siguientes posiciones?",
  "Positions blocked successfully":"Posiciones bloqueadas correctamente",
  "Error blocking positions":"Error al bloquear las posiciones",
  "Positions unblocked successfully":"Posiciones desbloqueadas correctamente",
  "Error unblocking positions":"Error al desbloquear las posiciones",
  "Blocked Positions":"Posiciones bloqueadas",
  "Unlocked positions":"Posiciones desbloqueadas",
  "All positions":"Todas las posiciones",
  "Lock removed successfully":"Bloqueo eliminado correctamente",
  "kpisDashboard":"Pizarra de kpi",
  "Total Inbounds":"Total de entradas",
  "Total Outbounds":"Total de salidas",
  "Error Types":"Tipos de errores",
  "Total Errors in Inbounds and Outbounds Today":"Errores totales en entradas y salidas hoy",
  "Kpi's Dashboard":"Pizarra de kpi",
  "Dashboard":"Panel",
  "totalMovements":"Total Movimientos",
  "movementsPerHour":"Movimientos por Hora",
  "movementsPerDay":"Movimientos por Día",
  "averageMovementTime":"Tiempo Medio de Movimiento",
  "movementsByType":"Movimientos por Tipo",
  "movementsByMachine":"Movimientos por Máquina",
  "movementsByZone":"Movimientos por Zona",
  "inboundMovements":"Movimientos de Entrada",
  "outboundMovements":"Movimientos de Salida",
  "internalMovements":"Movimientos Internos",
  "rotationMovements":"Movimientos de Rotación",
  "machineEfficiency":"Eficiencia de Máquina",
  "pendingMovements":"Movimientos Pendientes",
  "completedMovements":"Movimientos Completados",
  "inProgressMovements":"Movimientos en Progreso",
  "cancelledMovements":"Movimientos Cancelados",
  "averageCycleTime":"Tiempo de Ciclo Medio",
  "movementsTrend":"Tendencia de Movimientos",
  "sinceLastPeriod":"desde el período anterior",
  "pending":"Pendiente",
  "completed":"Completado",
  "inProgress":"En Progreso",
  "cancelled":"Cancelado",
  "No data available":"Sin datos disponibles",
  "Movements":"Movimientos",
  "delete":"Eliminar",
  "edit":"Editar",
  "positionType":"Tipo de Posición",
  "out":"Salida",
  "New Alarm Detected!":"Nueva alarma!",
  "Minimize":"Minimizar",
  "Maximize":"Maximizar",
  "TOTAL INBOUNDS":"TOTAL DE ENTRADAS",
  "Total Inbounds":"Total de entradas",
  "Today":"Hoy",
  "Hours":"Horas",
  "Daily":"Diario",
  "Weekly":"Semanal",
  "Monthly":"Mensual",
  "Average Inbounds per":"Promedio de entradas por",
  "Hour":"hora",
  "Day":"Día",
  "Monday":"Lunes",
  "Tuesday":"Martes",
  "Wednesday":"Miércoles",
  "Thursday":"Jueves",
  "Friday":"Viernes",
  "Saturday":"Sábado",
  "Sunday":"Domingo",
  "Week":"Semana",
  "Month":"Mes",
  "Inbounds":"Entradas",
  "Close":"Cerrar",
  "alternativeTypeNumber":"ID tipo de pallet WMS",
  "January":"Enero",
  "February":"Febrero",
  "March":"Marzo",
  "April":"Abril",
  "May":"Mayo",
  "June":"Junio",
  "July":"Julio",
  "August":"Agosto",
  "September":"Septiembre",
  "October":"Octubre",
  "November":"Noviembre",
  "December":"Diciembre",
  "repeatCurrentStep":"Repetir el paso actual",
  "You confirm that you want to repeat the current step with pallet ID: {palletId}?":"¿Confirma que desea repetir el paso actual con el ID del pallet: {palletId}?",
  "Outbounds":"Salidas",
  "TOTAL OUTBOUNDS":"TOTAL DE SALIDAS",
  "Total Outbounds":"Total de salidas",
  "Average Outbounds per":"Promedio de salidas por",
  "Average Errors per":"Promedio de errores por",
  "Priority":"Prioridad",
  "userId":"Id de usuario",
  "name":"Nombre",
  "username":"Nombre de usuario",
  "rol":"Rol",
  "editUser":"Editar usuario",
  "password":"Contraseña",
  "repeatPassword":"Repetir contraseña",
  "Are you sure you want to delete {name}?":"¿Estás seguro que quieres eliminar a {name}?",
  "deleteUser":"Eliminar usuario",
  "User {name} deleted":"Usuario {name} eliminado",
  "params":"Parámetros",
  "search":"Buscar",
  "new":"Nuevo",
  "edit":"Editar",
  "delete":"Eliminar",
  "editParam":"Editar parámetro",
  "newParam":"Nuevo parámetro",
  "key":"Clave",
  "value":"Valor",
  "pleaseEnterKey":"Por favor, introduzca una clave",
  "pleaseEnterValue":"Por favor, introduzca un valor",
  "update":"Actualizar",
  "save":"Guardar",
  "actions":"Acciones",
  "id":"Id",
  "added":"añadido",
  "successfully":"exitosamente",
  "deleteParam":"Eliminar parámetro",
  "areYouSureDeleteParam":"¿Estás seguro de que quieres eliminar el parámetro {key}?",
  "deletedSuccessfully":"eliminado exitosamente",
  "logger":"Registro",
  "applicationLogs":"Logs de Aplicación",
  "systemLogs":"Logs del Sistema",
  "selectLogFile":"Seleccionar archivo",
  "refresh":"Actualizar",
  "thread":"Hilo",
  "class":"Clase",
  "Error loading system logs":"Error al cargar logs del sistema",
  "close":"Cerrar",
  "search":"Buscar",
  "user":"Usuario",
  "searchByMessage":"Buscar por mensaje",
  "dataTime":"Fecha y hora",
  "level":"Nivel",
  "message":"Mensaje",
  "installationName":"Nombre de la instalación",
  "hmWareUrl":"URL de Hmware",
  "cmLogicUrl":"URL de Cmlogic",
  "cmLogicUser":"Usuario de Cmlogic",
  "cmLogicPassword":"Contraseña de Cmlogic",
  "wmsUrl":"URL de WMS",
  "wmsUser":"Usuario de WMS",
  "wmsPassword":"Contraseña de WMS",
  "imagesPath":"Ruta de imágenes",
  "analyticsUrl":"URL de analytics",
  "update":"Actualizar",
  "required":"Requerido",
  "updatedSuccessfully":"Actualizado correctamente",
  "TOTAL ERRORS":"TOTAL DE ERRORES",
  "Errors Type":"Tipos de errores",
  "Errors":"Errores",
  "Warehouse Occupancy":"Ocupación del almacén",
  "Free":"Libre",
  "Occupied":"Ocupado",
  "Occupied positions":"Posiciones ocupadas",
  "completed":"Completado",
  "takeOutStock":"Retirar stock",
  "No data available today":"No hay datos disponibles hoy",
  "Average Activity":"Actividad media",
  "Average Real-Time Activity per Machine":"Actividad media en tiempo real por máquina",
  "Activity":"Actividad",
  "inqueue":"Este pallet posiblemente está en la cola de movimientos",
  "batchNumber":"Número de lote",
  "warehouseViewer":"Visor de almacén",
  "priority":"Prioridad",
  "removalEmptyPallets":"Extracción de pallets vacíos",
  "newUser":"Nuevo usuario",
  "Select Block Depth":"Seleccionar Profundidad de Bloqueo",
  "Only depth 2":"Solo la segunda profundidad",
  "All depths":"Todas las profundidades",
  "Some positions were excluded as they do not have Second Depth":"Se han excluido algunas posiciones porque no tienen segunda profundidad.",
  "Please input pallet weight":"Introduzca el peso del pallet",
  "Please input pallet height":"Introduzca la altura del pallet",
  "allowedItems":"Artículos permitidos",
  "legendEmpty":"Posición libre",
  "legendFull":"Posición ocupada",
  "legendEmptyLocked":"Posición libre bloqueada",
  "legendFullLocked":"Posición ocupada bloqueada",
  "legendInstructions":"Para ver los detalles de una posición en la imagen, coloca el cursor sobre ella y haz doble clic. Si deseas girar la imagen, haz clic con el botón izquierdo y arrastra el ratón en la dirección deseada. Para mover la imagen, mantén presionado el botón derecho del ratón mientras mueves el cursor.",
  "visibleLabels":"Etiquetas de las bahías visibles",
  "inventoryBalance":"Balance de Inventario",
  "Free positions":"Posiciones libres",
  "runNow":"Ejecutar ahora",
  "serialNumber":"Número de serie",
  "families":"Familias",
  "nextStep":"Siguiente paso",
  "You confirm that current step is complete and run next step: {palletId}?":"¿Confirmas que el paso actual está completo y quieres continuar con el siguiente paso: {palletId}?",
  "download":"Descargar",
  "pause":"Pausa",
  "cameras": "Cámaras",
  "inventoryProcess": "Proceso de inventario",
  "inventoryRequest": "Solicitud de inventario",
  "inventoryType": "Tipo de inventario",
  "photo_counting": "Conteo de fotos",
  "inventory_counting": "Conteo de inventario",
  "viewPhoto": "Ver foto",
  "pending_return": "Pendiente de devolución",
  "You confirm that the following pallet doesn't exist: {palletId}?":"¿Confirmas que el siguiente pallet no existe: {palletId}?",
  "inventory":"Inventario",
  "showLive": "Ver en directo",
  "AVERAGE INBOUNDS PER HOUR":"PROMEDIO DE ENTRADAS POR HORA",
  "Average Inbounds per Hour":"Entradas por hora",
  "Error fetching data":"Error actualizando los datos",
  "Average Inbounds":"Promedio de entradas",
  "Failed to load data":"Error al cargar los datos",
  "Average":"Promedio",
  "AVERAGE OUTBOUNDS PER HOUR":"PROMEDIO DE SALIDAS POR HORA",
  "Average Outbounds per Hour":"Promedio de salidas por hora",
  "Average Outbounds":"Promedio de salidas",
  "TOTAL NUMBER OF REJECTED PALLETS": "NÚMERO TOTAL DE PALLETS RECHAZADOS",
  "Pallets Rejected": "Pallets Rechazados",
  "Total Number of Rejected": "Número Total de Rechazados",
  "since last month":"desde el mes pasado",
  "palletHeight": "Altura del pallet",
  "palletWidth": "Anchura del pallet",
  "palletWeight": "Peso del pallet",
  "palletDepth": "Profundidad del pallet",
  "machine":"Máquina",
  "valueMustBeGreaterAndLessThan": "El valor debe ser mayor que {min} y menor que {max}",
  "nextStep": "Siguiente paso",
  "You confirm that current step is complete and run next step: {palletId}?": "¿Confirmas que el paso actual está completo y quieres continuar con el siguiente paso: {palletId}?",
  "download": "Descargar",
  "stockAdjustment":"Ajust d'estoc",
  "PAUSE": "Pausa",
  "movSubType": "Subtipo de movimiento",
  "CANCELED": "Cancelado",
  "SUSPENDED": "Suspendido",
  "PICK_STATION": "Recogida de estación",
  "PICK_RACK":"Recogida de rack",
  "DROP_STATION":"Dejar en la estacion",
  "DROP_RACK":"Dejar en el rack",
  "INVENTORY":"Inventario",
  "DROP_GRAVITY_OUT":"Dejar en la salida por gravedad",
  "CONVEYOR":"Conveyor",
  "SHUTTLE":"Shuttle",
  "CONVEYOR_DS":"Conveyor DS",
  "Are you sure the pallet is there?" : "¿Estás seguro de que el pallet está ahí?",
  "conveyor side" : "Lado del conveyor",
  "systemSelected": "Sistema seleccionado",
  "system1": "Sistema 1",
  "system2": "Sistema 2",
  "system3": "Sistema 3",
  "statusUpdated": "Estado actualizado",
  "cancelInventoryProcess": "Cancelar proceso de inventario",
  "areYouSureInventoryProcess": "¿Está seguro de que desea cancelar el proceso de inventario?",
  "inventoryProcessCanceled": "Proceso de inventario cancelado",
  "TotalInboundsMoreInfo":"Muestra el número total de entradas de mercancía registradas en el almacén durante el período seleccionado. La flecha muestra la tendencia respecto al período anterior.",
  "TotalOutboundsMoreInfo":"Muestra el número total de salidas de mercancía registradas en el almacén durante el período seleccionado. La flecha muestra la tendencia respecto al período anterior.",
  "WarehouseOccupancyMoreInfo":"Representa el porcentaje del espacio de almacenamiento que está actualmente en uso. El gráfico de dona visualiza la proporción entre el espacio ocupado y el libre.",
  "AverageActivityMoreInfo":"Muestra la actividad promedio de las máquinas en el almacén durante el período seleccionado. La flecha indica la tendencia respecto al período anterior.",
  "TotalErrorsMoreInfo":"Muestra el número total de errores registrados en el almacén durante el período seleccionado. La flecha indica la tendencia respecto al período anterior.",
  "ErrorsTypeMoreInfo":"Muestra la distribución de los tipos de errores registrados en el almacén durante el período seleccionado. La flecha indica la tendencia respecto al período anterior.",
  "RejectReasonsMoreInfo":"Muestra las razones por las que los artículos fueron rechazados durante las operaciones de entrada o salida, ayudando a identificar patrones y mejorar la calidad del proceso.",
  "delete movement":"Eliminar movimiento",
  "Confirm and place pallet":"Confirmar y colocar pallet",
  "Running": "En ejecución",
  "Finish movement":"Finalizar movimiento",
  "Confirm all active alarms": "Confirmar todas las alarmas activas",
  "videos": "Vídeos",
  "Terminal":"Terminal",
  "noMatchesFound": "No se han encontrado coincidencias",
  "Confirm":"Confirmación",
  "Are you sure you want to confirm all active alarms? This action cannot be undone.": "¿Estás seguro de que deseas confirmar todas las alarmas activas?",
  "All active alarms confirmed successfully.": "Alarmas confirmadas con éxito",
  "No active alarms to confirm.": "No hay alarmas activas para confirmar",
  "charts": "Gráficos",
  "outbound": "salida",
  "inbound": "entrada",
  "lock": "bloquear",
  "lock_reason": "motivo de bloqueo",
  "unlock": "desbloquear",
  "yes": "sí",
  "no": "no",
  "cancel": "cancelar",
  "help": "ayuda",
  "occupation": "ocupación",
  "All":"Todos",
  "today":"Hoy",
  "last7days":"Últimos 7 días",
  "last30days":"Últimos 30 días",
  "Close":"Cerrar",
  "accessDenied": "No tiene permiso para acceder a esta página. Por favor, contacte con su administrador.",
  "systemLogs":"Logs del sistema",
  "logFile":"Archivo de log",
  "fromDate":"Desde fecha",
  "toDate":"Hasta fecha",
  "searchInTrace":"Buscar en traza",
  "dateTime":"Fecha",
  "logType":"Tipo",
  "class":"Clase",
  "trace":"Traza",
  "refresh":"Actualizar",
  "typeFilter":"Filtrar por tipo",
  "movements":"Movimientos",
  "Hour":"Hora",
  "Movement Time (Minutes)": "Tiempo de Movimiento (Minutos)",
  "Days": "Días",
  "Weeks": "Semanas",
  "Average Movement Time": "Tiempo Medio de Movimiento",
  "Day": "Día",
  "Week": "Semana",
  "Capacity per Hour": "Capacidad por hora",
  "Movements per Hour": "Movimientos por hora",
  "All Movements": "Todos los movimientos",
  "No results": "Sin resultados",
  "Outlier": "Outlier",
  "Movement Type": "Tipo de movimiento",
  "Process duration": "Duración del proceso",
  "Status": "Estado",
  "per Machine": "por Máquina",
  "Avg Movement Duration Trend": "Tendencia de duración media de movimiento",
  "Registered movements": "Movimientos registrados",
  "Picking": "Picking",
  "An unexpected error occurred": "Ocurrió un error inesperado",
  "Error loading data": "Error al cargar los datos",
  "Minutes": "Minutos",
  "Total Errors": "Total de errores",
  "Reject Reasons": "Motivos de rechazo",
  "Average Real-Time Activity": "Actividad media en tiempo real",
  "uptimeKpi":"Tiempo de actividad KPI",
   "capacityDashboard":"Capacidad del Almacén",
  "maintenanceResponse":"Respuesta de mantenimiento",
  "primaryKpi":"KPI primario",
  "totalTime":"Tiempo total",
  "stoppedTime":"Tiempo parado",
  "detailedAnalysisBySystem":"Análisis detallado por sistema",
  "HourlyViewSingleDaySelected":"Vista horaria - Un día seleccionado",
  "DailyViewMultipleDaysSelected":"Vista diaria - Múltiples días seleccionados",
  "uptime":"Tiempo de actividad",
  "FaultTime":"Tiempo de fallo",
  "FaultTime":"Tiempo de fallo",
  "AcknowledgmentTime":"Tiempo de reconocimiento",
  "RepairTime":"Tiempo de reparación",
  "ResolutionTime":"Tiempo de resolución",
  "Fault occurrence time → Maintenance acknowledgment time":"Tiempo de fallo → Tiempo de reconocimiento",
  "Maintenance acknowledgment time → Maintenance resolution time":"Tiempo de reconocimiento → Tiempo de resolución",
  "Fault occurrence time → Maintenance resolution time":"Tiempo de fallo → Tiempo de resolución",
  "avg":"Promedio",
  "minimum":"Mínimo",
  "maximum":"Máximo",
  "DowntimeAndErrorsPerDay":"Tiempo en fallo y errores por día",
  "DowntimeAndErrorCountPerDay":"Tiempo en fallo y conteo de errores por día",
  "DowntimeAndErrorCountPerHour":"Tiempo en fallo y conteo de errores por hora",
  "downtime":"Tiempo en fallo",
  "errorCount":"Conteo de errores",
  "AverageEvolutionOfResponseTime":"Evolución media del tiempo de respuesta",
  "TrendInMaintenanceTimes":"Tendencia en tiempos de mantenimiento",
  "acknowledgmentTime":"Tiempo de reconocimiento",
  "resolutionTime":"Tiempo de resolución",
  "ErrorBreakdown":"Desglose de errores",
  "DetailedHistoryOfFailuresAndResponseTimes":"Historial detallado de fallos y tiempos de respuesta",
  "system":"Sistema",
  "occurrence":"Ocurrencia",
  "repairTime":"Tiempo de reparación",
  "reactionTime":"Tiempo de reacción",
  "time":"Tiempo",
  "resolved":"Resuelto",
  "TotalErrors":"Total de errores",
  "InSelectedPeriod":"En el periodo seleccionado, la suma de errores de todos los sistemas.",
  "TotalDowntime":"Tiempo total en fallo",
  "HourlyAverage":"Promedio horario",
  "DailyAverage":"Promedio diario",
  "ErrorsPerHour":"Errores por hora de todos los sistemas",
  "ErrorsPerDay":"Errores por día de todos los sistemas",
  "Change password on next login":"Cambiar contraseña en el próximo inicio de sesión",
  "activeTasks":"Tareas activas",
  "An unexpected error occurred":"Se ha producido un error inesperado",
  "recoveryTime":"Tiempo de recuperación",
  "cumulativeTotal":"Total acumulado",
  "Total downtime":"Tiempo total en fallo",
  "Maintenance response time":"Tiempo de respuesta de mantenimiento",
  "Maintenance acknowledgment time → Maintenance arrival time":"Tiempo de reconocimiento → Tiempo de llegada",
  "Maintenance arrival time → Maintenance resolution time":"Tiempo de llegada → Tiempo de resolución",
  "notResolved":"No resuelto",
  "maxDaysMachineStopped":"{days} días desde que las máquinas están paradas",
  "SumOfTheTimeOfAllSystems":"Suma del tiempo de todos los sistemas",
  "Pallet Type / Height":"Tipo de pallet / Altura",
  "movementsKpi":"Duración de movimientos",
  "Registered movements":"Movimientos registrados",
  "Error loading data":"Error al cargar los datos",
  "Avg Movement Duration Trend":"Tendencia de duración promedio de movimientos",
  "Days":"Días",
  "Weeks":"Semanas",
  "Minutes":"Minutos",
  "Generate inbound":"Generar entrada",
  "Generate outbound":"Generar salida",
  "numberOfPallets":"Número de pallets",
  "generate":"Generar",
  "generateInboundDescription":"Genera {count} movimientos de entrada aleatorios para pruebas.",
  "generateOutboundDescription":"Genera {count} movimientos de salida aleatorios para pruebas. Opcionalmente filtrar por SKU.",
  "Height":"Altura",
  "Total positions":"Total de posiciones",
  "positions":"posiciones",
  "heightChartTitle":"Altura {letter} ({height} {unit})",
  "totalPositionsLabel":"Total de posiciones:",
	"noFreePositions":"No hay posiciones libres",
  "metricSystem": "Sistema métrico",
  "metricSystemIS": "Sistema Internacional (mm, kg)",
  "metricSystemUSCS": "Sistema consuetudinario de EE. UU. (in, lb)",
  "weight":"Peso",
  "analyticsUser":"Usuario de Analytics",
  "analyticsPassword":"Contraseña de Analytics",
  "localhostIp":"IP de localhost",
  "returnToHomeDelay":"Retardo de retorno a origen (segundos; 0 = desactivado)",
  "addContainer":"Añadir contenedor",
  "newInbound":"Nueva entrada",
  "newOutbound":"Nueva salida",
  "None":"Ninguno",
  "ROLE_ADMIN":"Administrador",
  "ROLE_COMMUNICATION":"Comunicación",
  "ROLE_WMS":"WMS",
  "ROLE_SUPERADMIN":"Superadministrador",
  "ROLE_USER":"Usuario",
  "ROLE_ENGINEERING":"Ingeniería",
  "ROLE_MAINTENANCE":"Mantenimiento",
  "Orders queue":"Cola de órdenes",
  "Orders history":"Historial de órdenes",
  "Pallets measures":"Medidas de palets",
  "PLC params":"Parámetros PLC",
  "Acquisition (PPA)":"Adquisición de nube de puntos (PPA)",
  "System Logs":"Registros del sistema",
};
